import fetch from '@/utils/fetch'

/**
 * 获取地块类型数量
 *
 * @export
 * @returns
 */
export function getLandNum() {
    return fetch.request({
        url: '/land/workbench',
        method: 'get'
    })
}
/**
 * 获取地块列表
 *
 * @export
 * @param {*} data 传给后台的数据

 * @returns promise
 */

export function getLandList(data, type) {
    return fetch.request({
        url: `/land/lands/${type}`,
        method: 'post',
        data

    })
}

/**
 * 获取地块列表new
 *
 * @export
 * @param {*} data 传给后台的数据

 * @returns promise
 */

export function getLandListNew(data, type) {
    return fetch.request({
        url: `/land/workbench/${type}`,
        method: 'post',
        data

    })
}

/**
 * 获取地块列表--有总平图
 *
 * @export
 * @param {*} data 传给后台的数据

 * @returns promise
 */

export function getLandImgList(data, type) {
    return fetch.request({
        url: `/land/lands/true/${type}`,
        method: 'post',
        data
    })
}

/**
 *提交 - 添加地块 走流程的
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getLandAddSubmit(data) {
    return fetch.request({
        url: '/land/preserve',
        method: 'post',
        data
    })
}

/**
 *暂存 - 添加地块 非提交 只是简单的提交后台
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getLandAdd(data) {
    return fetch.request({
        url: '/land/land/add',
        method: 'post',
        data
    })
}
/**
 *暂存 - 增加或更新
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getLandAddUpdate(data) {
    return fetch.request({
        url: '/land/reserve',
        method: 'post',
        data
    })
}
/**
 *新增页面  -  获取 id
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getNewLandId(data) {
    return fetch.request({
        url: '/sys/getNewPkId',
        method: 'get',
        data
    })
}
/**
 *获取数据词典
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getDataDict(data) {
    return fetch.request({
        url: '/sys/dataDict',
        method: 'post',
        data
    })
}

/**
 *获取数据城市
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getDataCity(data) {
    return fetch.request({
        url: '/market/citys',
        method: 'post',
        data
    })
}

/**
 *获取数据区域
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getDataArea(data) {
    return fetch.request({
        url: '/sys/citys/select',
        method: 'post',
        data
    })
}

/**
 *获取地块信息
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getLandDetail(landId) {
    if (landId) {
        return fetch.request({
            url: '/land/' + landId,
            method: 'get'
        })
    }

}

/**
 *获取地块头部信息
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getLandHead(landId) {
    return fetch.request({
        url: '/land/head/' + landId,
        method: 'get'
    })
}
/**
 *更新地块信息
 *
 * @export
 * @param {*} data
 * @returns
 */
export function updateLand(data) {
    return fetch.request({
        url: '/land/land/submit',
        method: 'post',
        data
    })
}
/**
 *更新地块信息
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getbasicsinformation(versionId) {
    return fetch.request({
        url: '/land/version/' + versionId,
        method: 'get'
    })
}

/**
 *获取项目信息
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getlLandProDetail(landId) {
    return fetch.request({
        url: '/land/' + landId,
        method: 'get'
    })
}
/**
 *删除地块信息
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getDelLand(landId) {
    return fetch.request({
        url: '/land/' + landId,
        method: 'delete'
    })
}
/**
 *获取事业部列表
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getBussinesDeptList(data) {
    return fetch.request({
        url: '/sys/bussinesDeptList',
        method: 'get',
        data
    })
}
/**
 *获取城市公司列表
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getCitycompanyList(orgDeptId) {
    return fetch.request({
        url: '/sys/bussinesDeptList/citycompany/' + orgDeptId,
        method: 'get'
    })
}
/**
 * 获取版块列表
 *
 * @export
 * @param {*} data 传给后台的数据
 * @returns promise
 */
export function getPlateList(data) {
    return fetch.request({
        url: '/market/plates',
        method: 'post',
        data
    })
}
/**
 *获取项目信息
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getLandBase(landId) {
    return fetch.request({
        url: '/land/base/' + landId,
        method: 'get'
    })
}
/**
 *获取项目各阶段的时间信息
 *
 * @export
 * @param {*} data
 * @returns
 */
export function getProjectDate(landId) {
    return fetch.request({
        url: 'land/head/stagetime/' + landId,
        method: 'get'
    })
}

/**
 * 根据地块landId 获取版本信息
 */
export function GetVersionId(obj) {
    if (!obj.blocFlag) {
        obj.blocFlag = ''
    }
    return fetch.request({
        url: `/business/land/${obj.landId}?blocFlag=${obj.blocFlag}`,
        method: 'get'
    })
}

/**
 * 根据已交保证金
 */
export function getMargin(data) {
    return fetch.request({
        url: '/land/lands/bond',
        method: 'post',
        data
    })
}

/**
 * 获取含有是否支持基础的信息
 */
export function baseInfo(landId) {
    return fetch.request({
        url: `/land/base/${landId}`,
        method: 'get'
    })
}
/**
 * 获取验证项目名称
 */
export function getVerify(data) {
    return fetch.request({
        url: '/land/verify/landName',
        method: 'post',
        data
    })
}
/**
 * 获取复制数据列表
 */
export function getCopyList(data) {
    return fetch.request({
        url: '/land/findLand',
        method: 'post',
        data
    })
}

/*
  获取拟上会通知详情

*/
export function getInterestedPlot(landId, taskId) {
    return fetch.request({
        url: `/land/getInterestedPlot/${landId}?taskId=${taskId}`,
        method: 'post'
    })
}

/*
  消除拟上会待办

*/
export function endInterestedPlotNotice(taskId) {
    return fetch.request({
        url: `/land/endInterestedPlotNotice/${taskId}`,
        method: 'get'
    })
}

/*
  激活项目
*/
export function activateProject(data) {
    return fetch.request({
        url: `/land/activation/${data.landId}?activType=${data.activType}`,
        method: 'get'
    })
}

/*
   获取历史版本
*/
export function history(landId) {
    return fetch.request({
        url: `/land/history/${landId}`,
        method: 'get'
    })
}
/*
   再次投票
*/
export function getTryAgain(landId) {
    return fetch.request({
        url: `/conferences/reGroupConference/${landId}`,
        method: 'get'
    })
}
/**
 * 项目可以编辑状态
 */
export function getOperationMark(key, businessId) {
    return fetch.request({
        url: `/sys/operationMark?key=${key}&businessId=${businessId}`,
        method: 'get'
    })
}
/**
 * 项目清除可编辑状态
 */
export function getClearCache(key, businessId) {
    return fetch.request({
        url: `/sys/delOperationMark?key=${key}&businessId=${businessId}`,
        method: 'get'
    })
}

/**
 * 获取项目投票次数
 */
export function committeeNumber(typeCode = 2, landId) {
    return fetch.request({
        url: `/conferences/committeeNumber/${typeCode}/${landId}`,
        method: 'get'
    })
}
